<div *ngIf="!!(screen.showRefreshButton$ | async)" (click)="refreshPage()" class="refresh-button button icon-button">
      <img src="/assets/icons/loading_arrow.svg" class="icon-white" alt="">
</div>
<ng-container *ngIf="!(screen.hideMainHeader$ | async)">
      <div *ngIf="!mobileUser" class="container" #headerBar>
            <div class="content">
                  <div class="logo-breadcrumb-wrapper">
                        <a class="logo-section" routerLink="">
                              <svg class="logo" width="285" height="49" viewBox="0 0 210 49" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <g id="Group 178">
                                          <rect id="streak_white" x="18" y="18" width="37" height="6" rx="3"
                                                fill="white" />
                                          <g id="logo">
                                                <rect id="streak_1" x="67" y="12" width="37" height="6" rx="3"
                                                      fill="#0D7377" />
                                                <rect id="streak_2" x="70" y="18" width="37" height="6" rx="3"
                                                      fill="#14FFEB" />
                                                <rect id="streak_3" x="73" y="24" width="37" height="6" rx="3"
                                                      fill="#FFA600" />
                                                <path id="prism"
                                                      d="M83.2535 26.75L72.4282 8C69.349 2.66667 61.651 2.66665 58.5718 7.99999L47.7465 26.75C44.6673 32.0833 48.5163 38.75 54.6747 38.75H76.3253C82.4837 38.75 86.3327 32.0834 83.2535 26.75Z"
                                                      fill="#323232" stroke="white" stroke-width="4" />
                                          </g>
                                          <text id="text" fill="#FFA600" xml:space="preserve" style="white-space: pre"
                                                font-family="Quicksand" font-size="24" font-weight="bold"
                                                letter-spacing="0em">
                                                <tspan x="115.074" y="28">prism</tspan>
                                          </text>
                                    </g>
                              </svg>
                        </a>
                        <ng-container *ngIf="(breadcrumbs$ | async) as breadcrumbs">
                              <div class="breadcrumb-tooltip" *ngIf="breadcrumbs.length">
                                    <ng-container *ngFor="let crumb of breadcrumbs; let last = last">
                                          <a *ngIf="!last" [routerLink]="crumb.url">{{ crumb.label }}</a>
                                          <span *ngIf="last" class="current">{{ crumb.label }}</span>
                                          <span *ngIf="!last" class="separator">></span>
                                    </ng-container>
                              </div>
                        </ng-container>
                  </div>
                  <ng-container *ngFor="let headerLink of headerLinks$ | async">
                        <div class="divider"></div>
                        <a class="main-title" [routerLink]="headerLink.routerLink">{{headerLink.label}}</a>
                  </ng-container>

                  <div class="right">
                        <ng-container *ngIf="(currentUser$ | async) as currentUser">
                              <div class="user-image">
                                    <img [src]="currentUser.thumbnailImageUrl">
                              </div>

                              <div class="name">{{(currentUser.firstName) + " " + (currentUser.lastName)}}</div>
                              <ng-container
                                    *ngVar="(unacknowledgedNotificationCount$ | async) as unacknowledgedNotificationCount">
                                    <div class="image" (click)="toggleNotificationSidebar()" #bellIcon
                                          [ngClass]="{'slow-flash': (unacknowledgedNotificationCount || 0) > 0}">
                                          <img src="/assets/icons/bell.svg"
                                                [ngClass]="{'icon-orange': (unacknowledgedNotificationCount || 0) > 0, 'icon-white': unacknowledgedNotificationCount === 0}">
                                          <div class="amount-indicator"
                                                *ngIf="(unacknowledgedNotificationCount || 0) > 0">
                                                {{unacknowledgedNotificationCount}}
                                          </div>
                                    </div>
                              </ng-container>
                              <ng-container *ngVar="(vacationCount$ | async) as vacationCount">
                                    <div class="image" (click)="toggleVacationSidebar()" #vacationIcon
                                          toolTip="vacations this week" [toolTipPosition]="TooltipPosition.BOTTOM">
                                          <img src="/assets/icons/calendar.svg" class="icon-white">
                                          <div class="amount-indicator vacation" *ngIf="(vacationCount || 0) > 0">
                                                {{vacationCount}}
                                          </div>
                                    </div>
                              </ng-container>
                              <div class="image" (click)="launchCreateSoftwareRequestDialog()"
                                    toolTip="request new software feature" [toolTipPosition]="TooltipPosition.BOTTOM">
                                    <img src="/assets/icons/bug.svg" class="icon-white" alt="">
                              </div>
                        </ng-container>
                        <!-- <div class="image" (click)="settings()" *ngIf="currentUser.abilities.settings.visible">
                              <img src="/assets/icons/gear.svg" class="icon-white">
                        </div> -->

                        <div *ngIf="(currentClientDevice$ | async)?.type === ClientDeviceType.KIOSK"
                              class="button square-button" (click)="launchClientDeviceInformationDialog()">
                              <img src="/assets/icons/monitor.svg" class="icon-white">
                        </div>

                        <button type="button" class="logout-icon" (click)="logout()" aria-label="logout"
                              toolTip="logout" [toolTipPosition]="TooltipPosition.BOTTOM">
                              <img src="/assets/icons/output.svg" class="icon-white" alt="">
                        </button>
                  </div>


            </div>

            <div class="streak"></div>
      </div>

      <div class="mobile-container" *ngIf="mobileUser" #mobileHeaderBar>

            <ng-container *ngIf="(currentUser$ | async) as currentUser">
                  <div class="mobile-content">

                        <svg viewBox="0 0 69 49" fill="none" xmlns="http://www.w3.org/2000/svg" routerLink="">
                              <rect x="26" y="12" width="37" height="6" rx="3" fill="#0D7377" />
                              <rect x="29" y="18" width="37" height="6" rx="3" fill="#14FFEB" />
                              <rect x="32" y="24" width="37" height="6" rx="3" fill="#FFA600" />
                              <path d="M42.2535 26.75L31.4282 8C28.349 2.66667 20.651 2.66665 17.5718 7.99999L6.74648 26.75C3.66728 32.0833 7.51626 38.75 13.6747 38.75H35.3253C41.4837 38.75 45.3327 32.0834 42.2535 26.75Z"
                                    fill="#323232" stroke="white" stroke-width="4" />
                        </svg>

                        <div class="header-row" [ngClass]="{'menu-open': mobileMenuExpanded$.value}">
                              <div (click)="refreshPage()" class="mobile-refresh-button">
                                    <img src="/assets/icons/loading_arrow.svg" class="icon-white" alt="">
                              </div>
                              <div class="user-image">
                                    <img [src]="currentUser.thumbnailImageUrl">
                              </div>

                              <ng-container
                                    *ngVar="(unacknowledgedNotificationCount$ | async) as unacknowledgedNotificationCount">
                                    <div class="image" (click)="toggleNotificationSidebar()" #bellIcon
                                          [ngClass]="{'slow-flash': (unacknowledgedNotificationCount || 0) > 0}">
                                          <img src="/assets/icons/bell.svg"
                                                [ngClass]="{'icon-orange': (unacknowledgedNotificationCount || 0) > 0, 'icon-white': unacknowledgedNotificationCount === 0}">
                                          <div class="amount-indicator"
                                                *ngIf="(unacknowledgedNotificationCount || 0) > 0">
                                                {{unacknowledgedNotificationCount}}
                                          </div>
                                    </div>
                              </ng-container>

                              <ng-container *ngVar="(vacationCount$ | async) as vacationCount">
                                    <div class="image" (click)="toggleVacationSidebar()" #vacationIcon>
                                          <img src="/assets/icons/calendar.svg" class="icon-white">
                                          <div class="amount-indicator vacation" *ngIf="(vacationCount || 0) > 0">
                                                {{vacationCount}}
                                          </div>
                                    </div>
                              </ng-container>

                              <div class="image" (click)="navigateToScanner()">
                                    <img src="/assets/icons/qr_code_scanner.svg" class="icon-white">
                              </div>

                              <img src="/assets/icons/menu.svg" class="icon-white" (click)="toggleMenuDropdown()"
                                    id="menu-toggle">
                        </div>
                  </div>

                  <div class="mobile-menu-panel" [ngClass]="{'open': mobileMenuExpanded$.value}" id="mobile-menu-panel">

                        <!-- <div *ngFor="let module of moduleOptions" class="module" (click)="navigateToModule($event, module)"> 
                              {{module}}
                        </div> -->

                        <ng-container *ngFor="let headerLink of headerLinks$ | async">
                              <a class="module-name" [routerLink]="headerLink.routerLink">{{headerLink.label}}</a>
                        </ng-container>

                        <div class="bottom">
                              <div class="user">
                                    <div class="user-image">
                                          <img [src]="currentUser.thumbnailImageUrl">
                                    </div>
                                    <div class="name">
                                          <div class="firstName">
                                                {{currentUser.firstName}}
                                          </div>

                                          <div class="lastName">
                                                {{currentUser.lastName}}
                                          </div>
                                    </div>
                              </div>
                              <div class="button" (click)="logout()">
                                    logout
                              </div>
                        </div>
                  </div>
            </ng-container>

      </div>

      <div class="notifications-container" #notificationPanel
            [ngStyle]="{'height': notificationContainerHeight, 'top': notificationContainerTop}"
            [ngClass]="{'open': showNotifications$.value, 'mobile': mobileUser}">
            <ng-container *ngIf="showNotifications$.value">
                  <ng-container *ngIf="userNotifications$ | async as userNotifications">
                        <div class="header" [ngClass]="{'mobile': mobileUser}">
                              <div class="notifications-heading"
                                    *ngIf="{data: (unacknowledgedNotificationCount$ | async)} as unacknowledgedNotificationCount">
                                    {{unacknowledgedNotificationCount.data}} unread
                                    notification{{unacknowledgedNotificationCount.data===1?'':'s'}}
                              </div>
                              <div class="notifications-subheading">
                                    Click ! to acknowledge, acknowledged leave after 1 day
                              </div>
                        </div>
                        <div class="close-button" (click)="showNotifications$.next(false)">
                              <img src="/assets/icons/close.svg" class="icon-white">
                        </div>
                        <div class="notifications-list">
                              <div class="notification" *ngFor="let notification of userNotifications"
                                    [ngClass]="{'acknowledged': notification.acknowledgedOn}">
                                    <div class="button circle-button"
                                          (click)="toggleNotificationAcknowledgement(notification, $event)"
                                          [ngClass]="{'selected': !notification.acknowledgedOn}">
                                          <img src="/assets/icons/exclamation.svg" class="icon-white">
                                    </div>
                                    <div class="information" [ngClass]="{
                              'url': notification.associatedUrl.length>0,
                              'disabled': notification.associatedUrl.length===0
                              }" (click)="openNotificationUrl(notification.associatedUrl)">
                                          <div class="description">{{notification.description}}</div>
                                          <div class="creation-date">
                                                <div class="day">{{notification.createdOn | date: 'cccc'}}</div>
                                                <div class="time-ago">({{notification.createdOn | timeDelta | async}})
                                                </div>
                                          </div>
                                    </div>
                              </div>
                              <div class="empty-section" *ngIf="userNotifications.length <= 0">
                                    No notifications
                              </div>
                        </div>
                        <div class="footer"
                              [ngClass]="{'disabled': allNotificationsAcknowledged(userNotifications),'mobile': mobileUser}"
                              (click)="acknowledgeAllNotifications(userNotifications)">
                              acknowledge all
                        </div>
                  </ng-container>
            </ng-container>
      </div>

      <div class="vacations-container" #vacationPanel
            [ngStyle]="{'height': notificationContainerHeight, 'top': notificationContainerTop}"
            *ngIf="vacationEvents$ | async as vacationEvents"
            [ngClass]="{'open': showVacations$.value, 'mobile': mobileUser}">
            <div class="header" [ngClass]="{'mobile': mobileUser}">
                  <div class="vacations-heading">
                        vacation summary
                  </div>
                  <div class="vacations-subheading">
                        Employee vacations in the next 7 days
                  </div>
            </div>
            <div class="close-button" (click)="showVacations$.next(false)">
                  <img src="/assets/icons/close.svg" class="icon-white">
            </div>
            <div class="vacations-list">
                  <div class="vacation" *ngFor="let vacation of vacationEvents"
                        [ngClass]="{'active-today': vacation.activeToday}">
                        <div class="employee-image">
                              <img *ngIf="!!vacation.employeeImageUrl" [src]="vacation.employeeImageUrl">
                              <div class="initials" *ngIf="!vacation.employeeImageUrl">{{vacation.employeeInitials}}</div>
                        </div>
                        <div class="person">
                              <div class="name">{{vacation.employeeName}}</div>
                              <div class="title" *ngIf="vacation.employeeTitle">{{vacation.employeeTitle}}</div>
                              <div class="notes" *ngIf="vacation.notes">{{vacation.notes}}</div>
                        </div>
                        <div class="vacation-meta">
                              <div class="dates">{{vacation.dateLabel}}</div>
                              <div class="status" *ngIf="vacation.activeToday">out today</div>
                        </div>
                  </div>
                  <div class="empty-section" *ngIf="vacationEvents.length <= 0">
                        No vacations in the next 7 days
                  </div>
            </div>
            <div class="footer" *ngIf="userCanManageVacations$ | async" [ngClass]="{'mobile': mobileUser}"
                  (click)="navigateToVacations()">
                  manage vacations
            </div>
      </div>
</ng-container>